import Link from "next/link";
import React from "react";

import SectionHeadings from "../../UI/CredSectionHeadings";
import { SupButton, SupText } from "@repo/core-ui";
import { SupLinkExternal } from "@repo/core-ui";
import LoyaltyBadge, { LoyaltyBadgeNone } from "../../UI/LoyaltyBadge";
import CredSection from "../../UI/CredSection";

interface CredHomeNFTProps {
  tier: string;
  boosts: number;
  isLoading?: boolean;
}

export default function CredHomeNFT({ isLoading, tier, boosts }: CredHomeNFTProps) {
  return (
    <CredSection>
      <div className="flex flex-col justify-between space-y-6  py-6 md:flex-row md:space-y-0  md:py-12">
        <SectionHeadings className="pb-0" heading="SUPERFREN NFT BOOST" subheading="BOOST FROM SEASON 1 SUPERFREN NFTS" />
        <div className="flex space-x-6">
          <Link href="https://opensea.io/collection/superfrensbysuperform" target="_blank" rel="noopener noreferrer">
            <SupButton color="primary" suffixIcon={<SupLinkExternal className="h-6 w-6" />} variant="outlined">
              View on OpenSea
            </SupButton>
          </Link>
          <Link href="/season1/nftboost/">
            <SupButton color="mauve">View Nft Boosts</SupButton>
          </Link>
        </div>
      </div>

      <div className="flex items-center space-x-4 ">
        {isLoading || boosts === 0 ? <LoyaltyBadgeNone /> : <LoyaltyBadge boost={boosts} size="sm" />}
        <div className="flex flex-col space-y-1">
          <SupText as="div" className="uppercase text-neutral-950" variant="body1" family="mono" weight="bold">
            {isLoading ? (
              <div className="h-6 w-48 animate-pulse rounded-md bg-neutral-200" />
            ) : tier === "0" || !tier ? (
              "NO NFT BOOST TIER COMPLETED"
            ) : (
              `${tier} TIER BOOST ACTIVATED`
            )}
          </SupText>
          <Link href="/season1/nftboost/">
            <SupText className="text-neutral-900 underline underline-offset-2 hover:no-underline" variant="body2" family="mono">
              VIEW DETAILS
            </SupText>
          </Link>
        </div>
      </div>
    </CredSection>
  );
}
